import BaseService from './BaseService';

class JobFollowerService extends BaseService{

  constructor() {
    super({ path: 'job-follower', entity: 'job-follower' });
  }
}

export default new JobFollowerService();
